'use client'

import Image from 'next/image'
import { IconWorld } from '@tabler/icons-react'
import { useState } from 'react'

interface WebsiteLogoProps {
  logo?: string
  url?: string
  name: string
}

export default function WebsiteLogo({ logo, url, name }: WebsiteLogoProps) {
  const [showFallback, setShowFallback] = useState(false);

  if (logo) {
    return (
      <Image
        src={logo}
        alt={name}
        width={48}
        height={48}
        className="object-cover"
      />
    )
  }

  if (url) {
    if (showFallback) {
      return (
        <div className="w-full h-full flex items-center justify-center bg-blue-50">
          <span className="text-xl font-semibold text-blue-600">
            {new URL(url).hostname.charAt(0).toUpperCase()}
          </span>
        </div>
      );
    }

    return (
      <div className="w-full h-full">
        <Image
          src={`https://favicon.im/${new URL(url).origin}`}
          alt={name}
          width={48}
          height={48}
          className="object-contain"
          onError={() => setShowFallback(true)}
        />
      </div>
    )
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-50">
      <IconWorld className="text-gray-400" size={24} />
    </div>
  )
} 